import script from "./alterationPhone.vue?vue&type=script&setup=true&lang=js"
export * from "./alterationPhone.vue?vue&type=script&setup=true&lang=js"

import "./alterationPhone.vue?vue&type=style&index=0&id=788f4676&lang=scss"

const __exports__ = script;

export default __exports__